export interface AblageRegel {
  id: string;
  aktiv: boolean;
  prioritaet: number;
  kategorie_id: string | null;
  stichwoerter: string[] | null;
  absender_typ: string | null;
  dateityp: string[] | null;
  ziel_pfad_vorlage: string;
  dokument_wort: string;
}

export interface Signale {
  kategorie_id: string | null;
  absender_typ: string | null;
  text: string;        // lowercase Betreff + Zusammenfassung + Dateiname
  dateiEndung: string; // lowercase, ohne Punkt
}

export function baueSignale(input: {
  kategorie_id?: string | null; absender_typ?: string | null;
  betreff?: string | null; zusammenfassung?: string | null; dateiname: string;
}): Signale {
  // Dateiname gehoert ins Text-Signal: bei Sammel-Mails (78 Anhaenge, generischer Betreff) steht NUR dort, was jede Datei ist (Wirtschaftsplan/Abrechnung/...).
  const text = `${input.betreff ?? ''} ${input.zusammenfassung ?? ''} ${input.dateiname ?? ''}`.toLowerCase();
  const m = /\.([A-Za-z0-9]+)$/.exec((input.dateiname ?? '').trim());
  return {
    kategorie_id: input.kategorie_id ?? null,
    absender_typ: input.absender_typ ?? null,
    text,
    dateiEndung: m ? m[1].toLowerCase() : '',
  };
}

// Greedy-Kollisionen: manche Stichwörter sind Teilwort eines längeren, semantisch fremden Worts.
// z. B. steckt "kündigung" in "ankündigung" (eine Lastschrift-ANKÜNDIGUNG ist KEINE Kündigung).
// Substring-Matching ist ansonsten gewollt (z. B. "rechnung" trifft "schlussrechnung") — daher
// wird hier nur die konkrete Kollision ausgeschlossen, statt global auf Wortgrenzen umzustellen.
const STICHWORT_AUSSCHLUSS: Record<string, string[]> = {
  'kündigung': ['ankündigung'],
  'kuendigung': ['ankuendigung'],
};

// Ein Stichwort matcht, wenn es im Text vorkommt — aber NICHT, wenn es ausschließlich aus einem
// Ausschluss-Wort stammt. Ausschluss-Wörter werden entfernt; bleibt das Stichwort dann noch übrig
// (echtes Vorkommen an anderer Stelle), gilt es weiterhin als Treffer.
export function stichwortMatcht(w: string, text: string): boolean {
  const lw = w.toLowerCase();
  if (!text.includes(lw)) return false;
  const ausschluss = STICHWORT_AUSSCHLUSS[lw];
  if (!ausschluss) return true;
  let rest = text;
  for (const a of ausschluss) rest = rest.split(a).join(' ');
  return rest.includes(lw);
}

function regelMatcht(r: AblageRegel, s: Signale): boolean {
  if (r.kategorie_id && r.kategorie_id !== s.kategorie_id) return false;
  if (r.absender_typ && r.absender_typ !== s.absender_typ) return false;
  if (r.dateityp && r.dateityp.length && !r.dateityp.map((d) => d.toLowerCase()).includes(s.dateiEndung)) return false;
  if (r.stichwoerter && r.stichwoerter.length && !r.stichwoerter.some((w) => stichwortMatcht(w, s.text))) return false;
  return true;
}

export function findeRegel(regeln: AblageRegel[], s: Signale): AblageRegel | null {
  const treffer = regeln.filter((r) => r.aktiv && regelMatcht(r, s));
  if (!treffer.length) return null;
  return treffer.reduce((a, b) => (b.prioritaet < a.prioritaet ? b : a));
}
